export class Autor {
  nome: string;
  referencia: string;
  email:  string;
  departamento: string;
  departamento_id: number;
  inst=true;
}



// WEBPACK FOOTER //
// ./src/app/autor/autor.ts